<template>
  <div class="chat__contact">
    <div
      class="chat__contact flex items-center px-2 pt-4 pb-2"
      :class="{ 'bg-primary-gradient text-white shadow-lg': isActiveChatUser }"
    >
      <div class="contact__avatar mr-1">
        <feather-icon icon="LinkIcon" svgClasses="h-5 w-5 ml-1" />
      </div>
      <div class="contact__container w-full flex items-center justify-between overflow-hidden">
        <div class="contact__info flex flex-col truncate w-full">
          <h5 class="font-semibold" :class="{ 'text-white': isActiveChatUser }">{{ contact.name }}</h5>          
        </div>

        <div class="chat__contact__meta flex self-start flex-col items-end w-1/6">
          <span class="whitespace-no-wrap">{{ contact.created_at | formDate }}</span>
          <!-- <vs-chip class="number" color="primary" v-if="unseenMsg">{{ unseenMsg }}</vs-chip> -->
        </div>
      </div>
    </div>
    <div class="flex justify-between items-center px-2 pb-2">
      <span class="truncate">{{ contact.driver }}</span>
      <span class="truncate w-1/2 text-right">{{ contact.companyName }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    contact: { type: Object, required: true },
    isActiveChatUser: { type: Boolean },
    lastMessaged: { type: String, default: "" },
    showLastMsg: { type: Boolean, default: false },
    unseenMsg: { type: Number, default: 0 }
  }
};
</script>
